import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import QueueingDetailPage from './QueueingDetailPage';
import './QueueingDetailPage.less';

export const prefix = 'bm-p-queueing-detail';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: QueueingDetailPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
